"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENRICH_AI_PREFIX = void 0;
exports.ENRICH_AI_PREFIX = 'ENRICH_AI:';
